import FormGroup from './form-group';
import FullnameInput from './fullname-input';
import TextInput from './text-input';
import ReadOnlyInput from './read-only-input';
import TextArea from './text-area';
import DateInput from './date-input';
import FormButtons from './form-buttons';
import CheckboxInput from './checkbox-input';
import {FormHorizental, FormInline} from './form';
import Autosuggest from './autosuggest';
import AuthorsInput from './authors-input';
import FileInput from './file-input';
import style from './style.css';


export {
  FormHorizental, FormInline, ReadOnlyInput,
  FormGroup, FullnameInput, FormButtons,
  TextInput, TextArea, DateInput, CheckboxInput,
  Autosuggest, AuthorsInput, FileInput, style};



// WEBPACK FOOTER //
// ./src/views/fragments/forms/index.js